import { render, staticRenderFns } from "./PlantillaGrifo.vue?vue&type=template&id=4b145791&scoped=true&"
import script from "./PlantillaGrifo.vue?vue&type=script&lang=js&"
export * from "./PlantillaGrifo.vue?vue&type=script&lang=js&"
import style0 from "./PlantillaGrifo.vue?vue&type=style&index=0&id=4b145791&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b145791",
  null
  
)

export default component.exports